import React from "react";
import { MdOutlineNavigateBefore, MdOutlineNavigateNext } from "react-icons/md";

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
    onPageChange: (page: number) => void;
    showItemsInfo?: boolean;
}

const Pagination: React.FC<PaginationProps> = ({
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    onPageChange,
    showItemsInfo = true
}) => {
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalItems);

    return (
        <nav
            aria-label="Pagination"
            className="mt-4 flex items-center justify-between px-4 py-3 sm:px-6"
        >
            {showItemsInfo && (
                <div className="hidden sm:block">
                    <p className="text-sm text-gray-700">
                        Showing <span className="font-medium">{startItem}</span> to <span className="font-medium">{endItem}</span> results
                    </p>
                </div>
            )}
            <div className="flex flex-1 justify-between sm:justify-end space-x-2">
                <div
                    className={`flex items-center rounded-md border border-primary-500 bg-white px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-primary-50 transition-all duration-300
                        ${currentPage === 1 ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
                        `}
                    onClick={() => {
                        if (currentPage > 1) {
                            onPageChange(Math.max(1, currentPage - 1));
                        }
                    }}
                >
                    Previous
                </div>
                <div
                    className={`flex items-center rounded-md border border-primary-500 bg-white px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-primary-50 transition-all duration-300
                        ${currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
                        `}
                    onClick={() => {
                        if (currentPage < totalPages) {
                            onPageChange(Math.min(totalPages, currentPage + 1));
                        }
                    }}
                >
                    Next
                </div>
            </div>
        </nav>
    );
};

export default Pagination;